var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcnArrowRightBoldDown16 = function SvgIcnArrowRightBoldDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12h12V0H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "evenodd",
    d: "M8.793 4a.5.5 0 0 1 .353.854L6.354 7.646a.5.5 0 0 1-.708 0L2.854 4.854A.5.5 0 0 1 3.207 4z",
    clipRule: "evenodd"
  })));
};
export default SvgIcnArrowRightBoldDown16;